import { useMemo, useState } from "react";
import { ProductCard } from "../components/products/ProductCard";
import { PageHero } from "../components/shared/PageHero";
import { PageMeta } from "../components/shared/PageMeta";
import { productCategories, products } from "../data/products";
import type { ProductCategory } from "../types/content";

export function ProductsPage() {
  const [category, setCategory] = useState<"Todos" | ProductCategory>("Todos");
  const filtered = useMemo(() => category === "Todos" ? products : products.filter((product) => product.category === category), [category]);

  return (
    <>
      <PageMeta title="Produtos | Pastelaria Casagrande" description="Conheça a pastelaria, salgados, refeições, bebidas e opções de encomenda da Pastelaria Casagrande." path="/produtos" />
      <PageHero eyebrow="Produtos" title="Sabores para todos os momentos" description="Conheça algumas das nossas opções e fale connosco para confirmar o que está disponível hoje." imageSlot="BALCAO" imageAlt="Balcão com produtos da Pastelaria Casagrande" />
      <section className="section section--surface">
        <div className="container">
          <div className="filters" role="group" aria-label="Filtrar produtos por categoria">
            {productCategories.map((item) => (
              <button key={item} type="button" aria-pressed={category === item} onClick={() => setCategory(item)}>{item}</button>
            ))}
          </div>
          <p className="results-count" aria-live="polite">{filtered.length} {filtered.length === 1 ? "produto" : "produtos"}</p>
          {filtered.length ? (
            <div className="products-grid">{filtered.map((product) => <ProductCard key={product.id} product={product} />)}</div>
          ) : (
            <div className="empty-state"><h2>Ainda não há produtos nesta categoria</h2><p>Escolha outra categoria ou fale connosco para saber o que está disponível.</p></div>
          )}
        </div>
      </section>
    </>
  );
}
